export const isDevEnv = import.meta.env.VITE_ENV.startsWith("development");
export const isProdEnv = import.meta.env.VITE_ENV.startsWith("production");
export const isStartDev = import.meta.env.VITE_ENV === "development.dev";
export const isStartTest = import.meta.env.VITE_ENV === "development.test";
export const isBuildTest = import.meta.env.VITE_ENV === "production.test";
export const isBuild = import.meta.env.VITE_ENV === "production";
